/* eslint-disable react-hooks/exhaustive-deps */
import { useSelector } from "react-redux";
import { RootState } from "@store/store";
import WaitingRoomMarketPlace from "@components/WaitingRooms/WaitingRoomMarketPlace";
import DefaultWaitingRoom from "@components/WaitingRooms/DefaultWaitingRoom";

const TaxSystemMap: Record<string, React.FC> = {
  CS005: WaitingRoomMarketPlace,
  CS006: WaitingRoomMarketPlace,
  CSPG1: WaitingRoomMarketPlace,
  CSPG2: WaitingRoomMarketPlace,
};

interface WaitingRoomProps {
  type: "WaitingRoom" | "WaitingRoomRevision" | "WaitingRoomRevisionCC";
}

const WaitingRoom = (props: WaitingRoomProps) => {
  const application = useSelector((state: RootState) => state.register.application);
  if (props.type !== "WaitingRoom") {
    return <DefaultWaitingRoom type={props.type} />;
  }

  const applicationType = application?.type;
  const Component = applicationType ? TaxSystemMap[applicationType] : undefined;

  if (!Component) {
    return <DefaultWaitingRoom type={props.type} />;
  }

  return <Component />;
};

export default WaitingRoom;
